import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { parseQueryString } from '../lib/parse-query-string';
import { RedirectService } from './redirect.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  private redirectService = inject(RedirectService);
  private storage = inject(StorageService);

  public async redirectAfterLogin(route: ActivatedRouteSnapshot) {
    const returnUrl: string =
      route.queryParams.returnUrl ||
      route.queryParams.redirect_url ||
      this.storage.get('loginReturnUrl') ||
      // (getReturnUrlFromRoute ? returnUrlFromRoute : null);
      this.storage.remove('loginReturnUrl');
    if (returnUrl) {
      if (returnUrl.includes('https://')) {
        return this.redirectService.externalRedirectTo(returnUrl);
      } else {
        const path = returnUrl.split('?')[0];
        const query = parseQueryString(returnUrl.split('?')[1]);
        return this.redirectService.redirectTo(path.split('/'), query);
      }
    } else {
      return this.redirectService.redirectTo(['a', 'home']);
    }
  }
}
